import { useCanCollect } from '@Hooks/useCanCollect';
import { type ApiOrder, EnumOrderType } from '@Model';
import { renderCurrency } from '@synqo/frontend-component-library';
import { useOrderTotals } from './useOrderTotals';

export function useCanCollectOrder(apiOrder: ApiOrder) {
    const isCashPayment = apiOrder.type === EnumOrderType.Cash;
    const { totalGrossPrice } = useOrderTotals(apiOrder);

    const { collectible, isStateApproved, canCollect, canApprove } = useCanCollect(
        isCashPayment,
        totalGrossPrice,
        apiOrder.process_state,
    );

    const actionText = totalGrossPrice >= 0 ? 'Jetzt kassieren' : 'Jetzt auszahlen';
    const tooltip =
        collectible && totalGrossPrice === 0
            ? `Der Betrag ${renderCurrency(0)} kann nicht kassiert werden.`
            : undefined;

    return {
        actionText,
        isCashPayment,
        isStateApproved,
        collectible,
        canCollect,
        canApprove,
        tooltip,
    };
}
